//----- AUTOGENERATED (changes will be overwritten) -------
import * as $runtime from "../runtime.js";
import * as Data$dDateTime from "../Data.DateTime/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUTCTime from "../Data.UTCTime/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Data$dValue from "../Data.Value/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dModifier from "../Restaumatic.Menu.V2.Types.Modifier/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dTaxes from "../Restaumatic.Menu.V2.Types.Taxes/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $ConfirmationSource = (tag, _1) => ({tag, _1});
const $ConfirmationStatus = (tag, _1) => ({tag, _1});
const $ItemDescription = (tag, _1) => ({tag, _1});
const $ItemRole = tag => ({tag});
const $ProductType = tag => ({tag});
const $SystemConfirmationStatus = tag => ({tag});
const PaymentDeclined = /* #__PURE__ */ $SystemConfirmationStatus("PaymentDeclined");
const PaymentTimeout = /* #__PURE__ */ $SystemConfirmationStatus("PaymentTimeout");
const PaymentAfterRestaurantClosed = /* #__PURE__ */ $SystemConfirmationStatus("PaymentAfterRestaurantClosed");
const ConfirmationTimeout = /* #__PURE__ */ $SystemConfirmationStatus("ConfirmationTimeout");
const Invalidated = /* #__PURE__ */ $SystemConfirmationStatus("Invalidated");
const ShortOrderId = x => x;
const Promotion = /* #__PURE__ */ $ProductType("Promotion");
const External = /* #__PURE__ */ $ProductType("External");
const Legacy = /* #__PURE__ */ $ProductType("Legacy");
const ParameterDescription = x => x;
const OrderUUID = x => x;
const OrderDraft = x => x;
const ModifierItemDescription = x => x;
const ModifierDescription = x => x;
const ProductPartDescription = x => x;
const Main = /* #__PURE__ */ $ItemRole("Main");
const Side = /* #__PURE__ */ $ItemRole("Side");
const Freebie = /* #__PURE__ */ $ItemRole("Freebie");
const Info = /* #__PURE__ */ $ItemRole("Info");
const FreebieDescription = value0 => $ItemDescription("FreebieDescription", value0);
const TextDescription = value0 => $ItemDescription("TextDescription", value0);
const ProductDescription = value0 => $ItemDescription("ProductDescription", value0);
const NoDescription = /* #__PURE__ */ $ItemDescription("NoDescription");
const IntegrationId = x => x;
const Customer = x => x;
const CorrectedTotal = x => x;
const Accepted = value0 => $ConfirmationStatus("Accepted", value0);
const Rejected = /* #__PURE__ */ $ConfirmationStatus("Rejected");
const AutoCancel = /* #__PURE__ */ $ConfirmationSource("AutoCancel");
const PR = value0 => $ConfirmationSource("PR", value0);
const ROS = value0 => $ConfirmationSource("ROS", value0);
const Email = /* #__PURE__ */ $ConfirmationSource("Email");
const CallCenter = value0 => $ConfirmationSource("CallCenter", value0);
const Printer = /* #__PURE__ */ $ConfirmationSource("Printer");
const Pendolino = /* #__PURE__ */ $ConfirmationSource("Pendolino");
const System = value0 => $ConfirmationSource("System", value0);
const APIIntegration = value0 => $ConfirmationSource("APIIntegration", value0);
const PosBistro = /* #__PURE__ */ $ConfirmationSource("PosBistro");
const AutoCallCenter = /* #__PURE__ */ $ConfirmationSource("AutoCallCenter");
const Portal = /* #__PURE__ */ $ConfirmationSource("Portal");
const Unknown = /* #__PURE__ */ $ConfirmationSource("Unknown");
const Confirmation = x => x;
const eqSystemConfirmationStatu = {
  eq: x => y => {
    if (x.tag === "PaymentDeclined") { return y.tag === "PaymentDeclined"; }
    if (x.tag === "PaymentTimeout") { return y.tag === "PaymentTimeout"; }
    if (x.tag === "PaymentAfterRestaurantClosed") { return y.tag === "PaymentAfterRestaurantClosed"; }
    if (x.tag === "ConfirmationTimeout") { return y.tag === "ConfirmationTimeout"; }
    if (x.tag === "Invalidated") { return y.tag === "Invalidated"; }
    return false;
  }
};
const eqShortOrderId = {eq: x => y => x === y};
const eqProductType = {
  eq: x => y => {
    if (x.tag === "Promotion") { return y.tag === "Promotion"; }
    if (x.tag === "External") { return y.tag === "External"; }
    if (x.tag === "Legacy") { return y.tag === "Legacy"; }
    return false;
  }
};
const eqParameterDescription = {eq: x => y => x.choice === y.choice && x.parameter === y.parameter};
const eqOrderUUID = {eq: x => y => x === y};
const eqOrderDraft = {eq: x => y => Foreign$dInternal$dStringify.unsafeStringify(x) === Foreign$dInternal$dStringify.unsafeStringify(y)};
const eqModifierItemDescription = {eq: x => y => x.modifierItem === y.modifierItem && x.quantity === y.quantity && x.value === y.value};
const eqModifierDescription = {
  eq: x => y => Data$dEq.eqArrayImpl(eqModifierItemDescription.eq)(x.addedItems)(y.addedItems) && Data$dEq.eqArrayImpl(eqModifierItemDescription.eq)(x.includedItems)(y.includedItems) && x.modifier === y.modifier && Data$dEq.eqArrayImpl(eqModifierItemDescription.eq)(x.removedItems)(y.removedItems) && x.value === y.value && (() => {
    if (x.vatRate.tag === "IncludedInProduct") { return y.vatRate.tag === "IncludedInProduct"; }
    if (x.vatRate.tag === "Separate") {
      if (y.vatRate.tag === "Separate") {
        if (x.vatRate._1.tag === "VatA") { return y.vatRate._1.tag === "VatA"; }
        if (x.vatRate._1.tag === "VatB") { return y.vatRate._1.tag === "VatB"; }
        if (x.vatRate._1.tag === "VatC") { return y.vatRate._1.tag === "VatC"; }
        if (x.vatRate._1.tag === "VatD") { return y.vatRate._1.tag === "VatD"; }
        if (x.vatRate._1.tag === "VatE") { return y.vatRate._1.tag === "VatE"; }
        if (x.vatRate._1.tag === "VatF") { return y.vatRate._1.tag === "VatF"; }
        if (x.vatRate._1.tag === "VatG") { return y.vatRate._1.tag === "VatG"; }
        return false;
      }
      return false;
    }
    return false;
  })()
};
const eqProductPartDescription = {
  eq: x => y => (() => {
    if (x.category.tag === "Nothing") { return y.category.tag === "Nothing"; }
    if (x.category.tag === "Just") {
      if (y.category.tag === "Just") { return x.category._1 === y.category._1; }
      return false;
    }
    return false;
  })() && Data$dEq.eqArrayImpl(eqModifierDescription.eq)(x.modifiers)(y.modifiers) && Data$dEq.eqArrayImpl(eqParameterDescription.eq)(x.parameters)(y.parameters) && x.product === y.product && x.value === y.value && (() => {
    if (x.vatRate.tag === "Nothing") { return y.vatRate.tag === "Nothing"; }
    if (x.vatRate.tag === "Just") {
      if (y.vatRate.tag === "Just") {
        if (x.vatRate._1.tag === "VatA") { return y.vatRate._1.tag === "VatA"; }
        if (x.vatRate._1.tag === "VatB") { return y.vatRate._1.tag === "VatB"; }
        if (x.vatRate._1.tag === "VatC") { return y.vatRate._1.tag === "VatC"; }
        if (x.vatRate._1.tag === "VatD") { return y.vatRate._1.tag === "VatD"; }
        if (x.vatRate._1.tag === "VatE") { return y.vatRate._1.tag === "VatE"; }
        if (x.vatRate._1.tag === "VatF") { return y.vatRate._1.tag === "VatF"; }
        if (x.vatRate._1.tag === "VatG") { return y.vatRate._1.tag === "VatG"; }
        return false;
      }
      return false;
    }
    return false;
  })()
};
const eqItemRole = {
  eq: x => y => {
    if (x.tag === "Main") { return y.tag === "Main"; }
    if (x.tag === "Side") { return y.tag === "Side"; }
    if (x.tag === "Freebie") { return y.tag === "Freebie"; }
    if (x.tag === "Info") { return y.tag === "Info"; }
    return false;
  }
};
const eqItemDescription = {
  eq: x => y => {
    if (x.tag === "FreebieDescription") {
      if (y.tag === "FreebieDescription") {
        return x._1.freebie === y._1.freebie && (() => {
          if (x._1.vatRate.tag === "Nothing") { return y._1.vatRate.tag === "Nothing"; }
          if (x._1.vatRate.tag === "Just") {
            if (y._1.vatRate.tag === "Just") {
              if (x._1.vatRate._1.tag === "VatA") { return y._1.vatRate._1.tag === "VatA"; }
              if (x._1.vatRate._1.tag === "VatB") { return y._1.vatRate._1.tag === "VatB"; }
              if (x._1.vatRate._1.tag === "VatC") { return y._1.vatRate._1.tag === "VatC"; }
              if (x._1.vatRate._1.tag === "VatD") { return y._1.vatRate._1.tag === "VatD"; }
              if (x._1.vatRate._1.tag === "VatE") { return y._1.vatRate._1.tag === "VatE"; }
              if (x._1.vatRate._1.tag === "VatF") { return y._1.vatRate._1.tag === "VatF"; }
              if (x._1.vatRate._1.tag === "VatG") { return y._1.vatRate._1.tag === "VatG"; }
              return false;
            }
            return false;
          }
          return false;
        })();
      }
      return false;
    }
    if (x.tag === "TextDescription") {
      if (y.tag === "TextDescription") {
        return x._1.description === y._1.description && (() => {
          if (x._1.vatRate.tag === "Nothing") { return y._1.vatRate.tag === "Nothing"; }
          if (x._1.vatRate.tag === "Just") {
            if (y._1.vatRate.tag === "Just") {
              if (x._1.vatRate._1.tag === "VatA") { return y._1.vatRate._1.tag === "VatA"; }
              if (x._1.vatRate._1.tag === "VatB") { return y._1.vatRate._1.tag === "VatB"; }
              if (x._1.vatRate._1.tag === "VatC") { return y._1.vatRate._1.tag === "VatC"; }
              if (x._1.vatRate._1.tag === "VatD") { return y._1.vatRate._1.tag === "VatD"; }
              if (x._1.vatRate._1.tag === "VatE") { return y._1.vatRate._1.tag === "VatE"; }
              if (x._1.vatRate._1.tag === "VatF") { return y._1.vatRate._1.tag === "VatF"; }
              if (x._1.vatRate._1.tag === "VatG") { return y._1.vatRate._1.tag === "VatG"; }
              return false;
            }
            return false;
          }
          return false;
        })();
      }
      return false;
    }
    if (x.tag === "ProductDescription") {
      if (y.tag === "ProductDescription") {
        return Data$dEq.eqArrayImpl(eqModifierDescription.eq)(x._1.modifiers)(y._1.modifiers) && Data$dEq.eqArrayImpl(eqParameterDescription.eq)(x._1.parameters)(y._1.parameters) && Data$dEq.eqArrayImpl(eqProductPartDescription.eq)(x._1.productParts)(y._1.productParts) && (() => {
          if (x._1.vatRate.tag === "Nothing") { return y._1.vatRate.tag === "Nothing"; }
          if (x._1.vatRate.tag === "Just") {
            if (y._1.vatRate.tag === "Just") {
              if (x._1.vatRate._1.tag === "VatA") { return y._1.vatRate._1.tag === "VatA"; }
              if (x._1.vatRate._1.tag === "VatB") { return y._1.vatRate._1.tag === "VatB"; }
              if (x._1.vatRate._1.tag === "VatC") { return y._1.vatRate._1.tag === "VatC"; }
              if (x._1.vatRate._1.tag === "VatD") { return y._1.vatRate._1.tag === "VatD"; }
              if (x._1.vatRate._1.tag === "VatE") { return y._1.vatRate._1.tag === "VatE"; }
              if (x._1.vatRate._1.tag === "VatF") { return y._1.vatRate._1.tag === "VatF"; }
              if (x._1.vatRate._1.tag === "VatG") { return y._1.vatRate._1.tag === "VatG"; }
              return false;
            }
            return false;
          }
          return false;
        })();
      }
      return false;
    }
    if (x.tag === "NoDescription") { return y.tag === "NoDescription"; }
    return false;
  }
};
const eqIntegrationId = {eq: x => y => x === y};
const eqCustomer = {
  eq: x => y => (() => {
    if (x.email.tag === "Nothing") { return y.email.tag === "Nothing"; }
    if (x.email.tag === "Just") {
      if (y.email.tag === "Just") { return x.email._1 === y.email._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.name.tag === "Nothing") { return y.name.tag === "Nothing"; }
    if (x.name.tag === "Just") {
      if (y.name.tag === "Just") { return x.name._1 === y.name._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.originalPhone.tag === "Nothing") { return y.originalPhone.tag === "Nothing"; }
    if (x.originalPhone.tag === "Just") {
      if (y.originalPhone.tag === "Just") { return x.originalPhone._1 === y.originalPhone._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.phone.tag === "Nothing") { return y.phone.tag === "Nothing"; }
    if (x.phone.tag === "Just") {
      if (y.phone.tag === "Just") { return x.phone._1 === y.phone._1; }
      return false;
    }
    return false;
  })()
};
const eqCorrectedTotal = {eq: x => y => x.reason === y.reason && x.total === y.total};
const eqConfirmationStatus = {
  eq: x => y => {
    if (x.tag === "Accepted") {
      if (y.tag === "Accepted") { return Data$dDateTime.eqDateTime.eq(x._1.deliveryTime)(y._1.deliveryTime); }
      return false;
    }
    if (x.tag === "Rejected") { return y.tag === "Rejected"; }
    return false;
  }
};
const eqConfirmationSource = {
  eq: x => y => {
    if (x.tag === "AutoCancel") { return y.tag === "AutoCancel"; }
    if (x.tag === "PR") {
      if (y.tag === "PR") {
        return x._1.staffId === y._1.staffId && (() => {
          if (x._1.staffName.tag === "Nothing") { return y._1.staffName.tag === "Nothing"; }
          if (x._1.staffName.tag === "Just") {
            if (y._1.staffName.tag === "Just") { return x._1.staffName._1 === y._1.staffName._1; }
            return false;
          }
          return false;
        })();
      }
      return false;
    }
    if (x.tag === "ROS") {
      if (y.tag === "ROS") {
        return x._1.staffId === y._1.staffId && (() => {
          if (x._1.staffName.tag === "Nothing") { return y._1.staffName.tag === "Nothing"; }
          if (x._1.staffName.tag === "Just") {
            if (y._1.staffName.tag === "Just") { return x._1.staffName._1 === y._1.staffName._1; }
            return false;
          }
          return false;
        })() && (() => {
          if (x._1.terminalId.tag === "Nothing") { return y._1.terminalId.tag === "Nothing"; }
          if (x._1.terminalId.tag === "Just") {
            if (y._1.terminalId.tag === "Just") { return x._1.terminalId._1 === y._1.terminalId._1; }
            return false;
          }
          return false;
        })();
      }
      return false;
    }
    if (x.tag === "Email") { return y.tag === "Email"; }
    if (x.tag === "CallCenter") {
      if (y.tag === "CallCenter") { return x._1.adminUserId === y._1.adminUserId; }
      return false;
    }
    if (x.tag === "Printer") { return y.tag === "Printer"; }
    if (x.tag === "Pendolino") { return y.tag === "Pendolino"; }
    if (x.tag === "System") {
      if (y.tag === "System") {
        if (x._1.status.tag === "PaymentDeclined") { return y._1.status.tag === "PaymentDeclined"; }
        if (x._1.status.tag === "PaymentTimeout") { return y._1.status.tag === "PaymentTimeout"; }
        if (x._1.status.tag === "PaymentAfterRestaurantClosed") { return y._1.status.tag === "PaymentAfterRestaurantClosed"; }
        if (x._1.status.tag === "ConfirmationTimeout") { return y._1.status.tag === "ConfirmationTimeout"; }
        if (x._1.status.tag === "Invalidated") { return y._1.status.tag === "Invalidated"; }
        return false;
      }
      return false;
    }
    if (x.tag === "APIIntegration") {
      if (y.tag === "APIIntegration") { return x._1.integration === y._1.integration; }
      return false;
    }
    if (x.tag === "PosBistro") { return y.tag === "PosBistro"; }
    if (x.tag === "AutoCallCenter") { return y.tag === "AutoCallCenter"; }
    if (x.tag === "Portal") { return y.tag === "Portal"; }
    if (x.tag === "Unknown") { return y.tag === "Unknown"; }
    return false;
  }
};
const eqConfirmation = {
  eq: x => y => Data$dDateTime.eqDateTime.eq(x.confirmedAt)(y.confirmedAt) && (() => {
    if (x.message.tag === "Nothing") { return y.message.tag === "Nothing"; }
    if (x.message.tag === "Just") {
      if (y.message.tag === "Just") { return x.message._1 === y.message._1; }
      return false;
    }
    return false;
  })() && eqConfirmationSource.eq(x.source)(y.source) && eqConfirmationStatus.eq(x.status)(y.status)
};
const newtypeShortOrderId = {Coercible0: () => {}};
const newtypeProductPartDescription = {Coercible0: () => {}};
const newtypeParameterDescription = {Coercible0: () => {}};
const newtypeOrderUUID = {Coercible0: () => {}};
const newtypeOrderDraft = {Coercible0: () => {}};
const newtypeModifierItemDescription = {Coercible0: () => {}};
const newtypeModifierDescription = {Coercible0: () => {}};
const newtypeIntegrationId = {Coercible0: () => {}};
const newtypeCustomer = {Coercible0: () => {}};
const newtypeCorrectedTotal = {Coercible0: () => {}};
const newtypeConfirmation = {Coercible0: () => {}};
const hasFieldProductPartDescription = dictHasField => dictHasField;
const hasFieldParameterDescription = dictHasField => dictHasField;
const hasFieldModifierItemDescription = dictHasField => dictHasField;
const hasFieldModifierDescription = dictHasField => dictHasField;
const hasFieldCustomer = dictHasField => dictHasField;
const hasFieldCorrectedTotal = dictHasField => dictHasField;
const hasFieldConfirmation = dictHasField => dictHasField;
const genericSystemConfirmationStatus = {
  to: x => {
    if (x.tag === "Inl") { return PaymentDeclined; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return PaymentTimeout; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return PaymentAfterRestaurantClosed; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return ConfirmationTimeout; }
          if (x._1._1._1.tag === "Inr") { return Invalidated; }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "PaymentDeclined") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "PaymentTimeout") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "PaymentAfterRestaurantClosed") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)));
    }
    if (x.tag === "ConfirmationTimeout") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "Invalidated") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))));
    }
    $runtime.fail();
  }
};
const showSystemConfirmationStatus = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "PaymentDeclined"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "PaymentTimeout"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "PaymentAfterRestaurantClosed"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "ConfirmationTimeout"});
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Invalidated"});
    return x => {
      const $5 = genericSystemConfirmationStatus.from(x);
      if ($5.tag === "Inl") { return $0["genericShow'"]($5._1); }
      if ($5.tag === "Inr") {
        if ($5._1.tag === "Inl") { return $1["genericShow'"]($5._1._1); }
        if ($5._1.tag === "Inr") {
          if ($5._1._1.tag === "Inl") { return $2["genericShow'"]($5._1._1._1); }
          if ($5._1._1.tag === "Inr") {
            if ($5._1._1._1.tag === "Inl") { return $3["genericShow'"]($5._1._1._1._1); }
            if ($5._1._1._1.tag === "Inr") { return $4["genericShow'"]($5._1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeSystemConfirmationStatus = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericSystemConfirmationStatus)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("PaymentDeclined"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("PaymentTimeout"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("PaymentAfterRestaurantClosed"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("ConfirmationTimeout"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Invalidated"), Data$dGeneric$dRep.NoArguments)]})))))(Unscramble$dEnum.defaultEnumOptions)
};
const genericShortOrderId = {to: x => x, from: x => x};
const showShortOrderId = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showIntImpl(v)]})({reflectSymbol: () => "ShortOrderId"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeShortOrderId = {unsafeDecode: x => Unscramble.decodeInt(x)};
const genericProductType = {
  to: x => {
    if (x.tag === "Inl") { return Promotion; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return External; }
      if (x._1.tag === "Inr") { return Legacy; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Promotion") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "External") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "Legacy") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)); }
    $runtime.fail();
  }
};
const showProductType = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Promotion"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "External"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Legacy"});
    return x => {
      const $3 = genericProductType.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeProductType = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericProductType)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Promotion"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("External"), Data$dGeneric$dRep.NoArguments)]})({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Legacy"), Data$dGeneric$dRep.NoArguments)]
  })))(Unscramble$dEnum.defaultEnumOptions)
};
const genericProductPartDescription = {to: x => x, from: x => x};
const genericParameterDescription = {to: x => x, from: x => x};
const showParameterDescription = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["choice", Data$dShow.showStringImpl(v.choice)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "parameter",
            Data$dShow.showStringImpl(v.parameter)
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ParameterDescription"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeParameterDescription = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "choice"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "parameter"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericOrderUUID = {to: x => x, from: x => x};
const showOrderUUID = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "OrderUUID"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeOrderUUID = {unsafeDecode: x => Data$dUUID.udecodeUUID.unsafeDecode(x)};
const genericOrderDraft = {to: x => x, from: x => x};
const showOrderDraft = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dValue.showValue.show(v)]})({reflectSymbol: () => "OrderDraft"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeOrderDraft = {unsafeDecode: x => x};
const genericModifierItemDescription = {to: x => x, from: x => x};
const showModifierItemDescription = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["modifierItem", Data$dShow.showStringImpl(v.modifierItem)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "quantity",
            Data$dShow.showIntImpl(v.quantity)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["value", Data$dMoney$dRounded.toString(v.value)]))([])));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ModifierItemDescription"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeModifierItemDescription = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "modifierItem"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "quantity"
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({reflectSymbol: () => "value"})(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericModifierDescription = {to: x => x, from: x => x};
const showModifierDescription = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(showModifierItemDescription.show);
      const $1 = Data$dShow.showArrayImpl(showModifierItemDescription.show);
      const $2 = Data$dShow.showArrayImpl(showModifierItemDescription.show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["addedItems", $2(v.addedItems)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "includedItems",
              $1(v.includedItems)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["modifier", Data$dShow.showStringImpl(v.modifier)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "removedItems",
              $0(v.removedItems)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["value", Data$dMoney$dRounded.toString(v.value)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "vatRate",
              Restaumatic$dMenu$dV2$dTypes$dModifier.showModifierVatRate.show(v.vatRate)
            ]))([]))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "ModifierDescription"});
    return x => $0["genericShow'"](x);
  })()
};
const showProductPartDescription = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(showParameterDescription.show);
      const $1 = Data$dShow.showArrayImpl(showModifierDescription.show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
              "category",
              (() => {
                if (v.category.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.category._1) + ")"; }
                if (v.category.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["modifiers", $1(v.modifiers)]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["parameters", $0(v.parameters)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "product",
              Data$dShow.showStringImpl(v.product)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["value", Data$dMoney$dRounded.toString(v.value)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "vatRate",
              (() => {
                if (v.vatRate.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dTaxes.showVatRate.show(v.vatRate._1) + ")"; }
                if (v.vatRate.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))([]))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "ProductPartDescription"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeModifierDescription = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "addedItems"})({
      unsafeDecode: Unscramble.decodeArray(unscrambleDecodeModifierItemDescription.unsafeDecode)
    })(Unscramble.decodeRecordCons({reflectSymbol: () => "includedItems"})({unsafeDecode: Unscramble.decodeArray(unscrambleDecodeModifierItemDescription.unsafeDecode)})(Unscramble.decodeRecordCons({
      reflectSymbol: () => "modifier"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordCons({reflectSymbol: () => "removedItems"})({
      unsafeDecode: Unscramble.decodeArray(unscrambleDecodeModifierItemDescription.unsafeDecode)
    })(Unscramble.decodeRecordCons({reflectSymbol: () => "value"})(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons({reflectSymbol: () => "vatRate"})(Restaumatic$dMenu$dV2$dTypes$dModifier.unscrambleDecodeModifierVatRate)(Unscramble.decodeRecordNil)))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeProductPartDescription = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "category"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "modifiers"
    })({unsafeDecode: Unscramble.decodeArray(unscrambleDecodeModifierDescription.unsafeDecode)})(Unscramble.decodeRecordCons({reflectSymbol: () => "parameters"})({
      unsafeDecode: Unscramble.decodeArray(unscrambleDecodeParameterDescription.unsafeDecode)
    })(Unscramble.decodeRecordCons({reflectSymbol: () => "product"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({reflectSymbol: () => "value"})(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "vatRate"
    })(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dTaxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericItemRole = {
  to: x => {
    if (x.tag === "Inl") { return Main; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return Side; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return Freebie; }
        if (x._1._1.tag === "Inr") { return Info; }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Main") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Side") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "Freebie") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "Info") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))); }
    $runtime.fail();
  }
};
const showItemRole = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Main"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Side"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Freebie"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Info"});
    return x => {
      const $4 = genericItemRole.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeItemRole = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericItemRole)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Main"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Side"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Freebie"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Info"), Data$dGeneric$dRep.NoArguments)]}))))(Unscramble$dEnum.defaultEnumOptions)
};
const genericItemDescription = {
  to: x => {
    if (x.tag === "Inl") { return $ItemDescription("FreebieDescription", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $ItemDescription("TextDescription", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $ItemDescription("ProductDescription", x._1._1._1); }
        if (x._1._1.tag === "Inr") { return NoDescription; }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "FreebieDescription") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "TextDescription") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "ProductDescription") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "NoDescription") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))); }
    $runtime.fail();
  }
};
const showItemDescription = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["freebie", Data$dShow.showStringImpl(v.freebie)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "vatRate",
            (() => {
              if (v.vatRate.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dTaxes.showVatRate.show(v.vatRate._1) + ")"; }
              if (v.vatRate.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "FreebieDescription"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["description", Data$dShow.showStringImpl(v.description)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "vatRate",
            (() => {
              if (v.vatRate.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dTaxes.showVatRate.show(v.vatRate._1) + ")"; }
              if (v.vatRate.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "TextDescription"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $2 = Data$dShow.showArrayImpl(showProductPartDescription.show);
      const $3 = Data$dShow.showArrayImpl(showParameterDescription.show);
      const $4 = Data$dShow.showArrayImpl(showModifierDescription.show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["modifiers", $4(v.modifiers)]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["parameters", $3(v.parameters)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "productParts",
              $2(v.productParts)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "vatRate",
              (() => {
                if (v.vatRate.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dTaxes.showVatRate.show(v.vatRate._1) + ")"; }
                if (v.vatRate.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))([]))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "ProductDescription"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "NoDescription"});
    return x => {
      const $4 = genericItemDescription.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeItemDescription = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "FreebieDescription"
    })({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "freebie"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
        reflectSymbol: () => "vatRate"
      })(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dTaxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "TextDescription"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "description"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
        reflectSymbol: () => "vatRate"
      })(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dTaxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "ProductDescription"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "modifiers"})({
        unsafeDecode: Unscramble.decodeArray(unscrambleDecodeModifierDescription.unsafeDecode)
      })(Unscramble.decodeRecordCons({reflectSymbol: () => "parameters"})({unsafeDecode: Unscramble.decodeArray(unscrambleDecodeParameterDescription.unsafeDecode)})(Unscramble.decodeRecordCons({
        reflectSymbol: () => "productParts"
      })({unsafeDecode: Unscramble.decodeArray(unscrambleDecodeProductPartDescription.unsafeDecode)})(Unscramble.decodeRecordCons({reflectSymbol: () => "vatRate"})(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dTaxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({reflectSymbol: () => "NoDescription"})))))(Unscramble$dGeneric.defaultOptions);
    return x => genericItemDescription.to($0(x));
  })()
};
const genericIntegrationId = {to: x => x, from: x => x};
const showIntegrationId = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showIntImpl(v)]})({reflectSymbol: () => "IntegrationId"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeIntegrationId = {unsafeDecode: x => Unscramble.decodeInt(x)};
const genericCustomer = {to: x => x, from: x => x};
const showCustomer = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
            "email",
            (() => {
              if (v.email.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.email._1) + ")"; }
              if (v.email.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "name",
            (() => {
              if (v.name.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.name._1) + ")"; }
              if (v.name.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "originalPhone",
            (() => {
              if (v.originalPhone.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.originalPhone._1) + ")"; }
              if (v.originalPhone.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "phone",
            (() => {
              if (v.phone.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.phone._1) + ")"; }
              if (v.phone.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([]))));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "Customer"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCustomer = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "email"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "name"
    })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({reflectSymbol: () => "originalPhone"})(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "phone"
    })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericCorrectedTotal = {to: x => x, from: x => x};
const showCorrectedTotal = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["reason", Data$dShow.showStringImpl(v.reason)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "total",
            Data$dMoney$dRounded.toString(v.total)
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "CorrectedTotal"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCorrectedTotal = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "reason"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "total"
    })(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericConfirmationStatus = {
  to: x => {
    if (x.tag === "Inl") { return $ConfirmationStatus("Accepted", x._1); }
    if (x.tag === "Inr") { return Rejected; }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Accepted") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "Rejected") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
    $runtime.fail();
  }
};
const showConfirmationStatus = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["deliveryTime", DateUtils.formatISODateTime(v.deliveryTime)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "Accepted"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Rejected"});
    return x => {
      if (x.tag === "Accepted") { return $0["genericShow'"](x._1); }
      if (x.tag === "Rejected") { return $1["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeConfirmationStatus = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "Accepted"
    })({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "deliveryTime"})(Data$dUTCTime.unscrambleDecodeUTCTime)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({reflectSymbol: () => "Rejected"})))(Unscramble$dGeneric.defaultOptions);
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Inl") { return $ConfirmationStatus("Accepted", $1._1); }
      if ($1.tag === "Inr") { return Rejected; }
      $runtime.fail();
    };
  })()
};
const genericConfirmationSource = {
  to: x => {
    if (x.tag === "Inl") { return AutoCancel; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $ConfirmationSource("PR", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $ConfirmationSource("ROS", x._1._1._1); }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return Email; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return $ConfirmationSource("CallCenter", x._1._1._1._1._1); }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return Printer; }
              if (x._1._1._1._1._1.tag === "Inr") {
                if (x._1._1._1._1._1._1.tag === "Inl") { return Pendolino; }
                if (x._1._1._1._1._1._1.tag === "Inr") {
                  if (x._1._1._1._1._1._1._1.tag === "Inl") { return $ConfirmationSource("System", x._1._1._1._1._1._1._1._1); }
                  if (x._1._1._1._1._1._1._1.tag === "Inr") {
                    if (x._1._1._1._1._1._1._1._1.tag === "Inl") { return $ConfirmationSource("APIIntegration", x._1._1._1._1._1._1._1._1._1); }
                    if (x._1._1._1._1._1._1._1._1.tag === "Inr") {
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inl") { return PosBistro; }
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return AutoCallCenter; }
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return Portal; }
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") { return Unknown; }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "AutoCancel") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "PR") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "ROS") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "Email") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "CallCenter") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))));
    }
    if (x.tag === "Printer") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    if (x.tag === "Pendolino") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
          )
        )
      );
    }
    if (x.tag === "System") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
          )
        )
      );
    }
    if (x.tag === "APIIntegration") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
            )
          )
        )
      );
    }
    if (x.tag === "PosBistro") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "AutoCallCenter") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "Portal") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "Unknown") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    $runtime.fail();
  }
};
const showConfirmationSource = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "AutoCancel"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["staffId", Data$dShow.showIntImpl(v.staffId)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "staffName",
            (() => {
              if (v.staffName.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.staffName._1) + ")"; }
              if (v.staffName.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "PR"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["staffId", Data$dShow.showIntImpl(v.staffId)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "staffName",
            (() => {
              if (v.staffName.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.staffName._1) + ")"; }
              if (v.staffName.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "terminalId",
            (() => {
              if (v.terminalId.tag === "Just") { return "(Just " + Data$dShow.showIntImpl(v.terminalId._1) + ")"; }
              if (v.terminalId.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))([])));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ROS"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Email"});
    const $4 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["adminUserId", Data$dShow.showIntImpl(v.adminUserId)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "CallCenter"});
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Printer"});
    const $6 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Pendolino"});
    const $7 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["status", showSystemConfirmationStatus.show(v.status)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "System"});
    const $8 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["integration", showIntegrationId.show(v.integration)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "APIIntegration"});
    const $9 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "PosBistro"});
    const $10 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "AutoCallCenter"});
    const $11 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Portal"});
    const $12 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Unknown"});
    return x => {
      const $13 = genericConfirmationSource.from(x);
      if ($13.tag === "Inl") { return $0["genericShow'"]($13._1); }
      if ($13.tag === "Inr") {
        if ($13._1.tag === "Inl") { return $1["genericShow'"]($13._1._1); }
        if ($13._1.tag === "Inr") {
          if ($13._1._1.tag === "Inl") { return $2["genericShow'"]($13._1._1._1); }
          if ($13._1._1.tag === "Inr") {
            if ($13._1._1._1.tag === "Inl") { return $3["genericShow'"]($13._1._1._1._1); }
            if ($13._1._1._1.tag === "Inr") {
              if ($13._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($13._1._1._1._1._1); }
              if ($13._1._1._1._1.tag === "Inr") {
                if ($13._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($13._1._1._1._1._1._1); }
                if ($13._1._1._1._1._1.tag === "Inr") {
                  if ($13._1._1._1._1._1._1.tag === "Inl") { return $6["genericShow'"]($13._1._1._1._1._1._1._1); }
                  if ($13._1._1._1._1._1._1.tag === "Inr") {
                    if ($13._1._1._1._1._1._1._1.tag === "Inl") { return $7["genericShow'"]($13._1._1._1._1._1._1._1._1); }
                    if ($13._1._1._1._1._1._1._1.tag === "Inr") {
                      if ($13._1._1._1._1._1._1._1._1.tag === "Inl") { return $8["genericShow'"]($13._1._1._1._1._1._1._1._1._1); }
                      if ($13._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if ($13._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $9["genericShow'"]($13._1._1._1._1._1._1._1._1._1._1); }
                        if ($13._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if ($13._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $10["genericShow'"]($13._1._1._1._1._1._1._1._1._1._1._1); }
                          if ($13._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if ($13._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $11["genericShow'"]($13._1._1._1._1._1._1._1._1._1._1._1._1); }
                            if ($13._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") { return $12["genericShow'"]($13._1._1._1._1._1._1._1._1._1._1._1._1); }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeConfirmationSource = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "AutoCancel"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "PR"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "staffId"})(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({
        reflectSymbol: () => "staffName"
      })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "ROS"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "staffId"})(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({
        reflectSymbol: () => "staffName"
      })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({reflectSymbol: () => "terminalId"})(Unscramble.decodeMaybe(Unscramble.decodeInt1))(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({reflectSymbol: () => "Email"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "CallCenter"
    })({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "adminUserId"})(Unscramble.decodeInt1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({reflectSymbol: () => "Printer"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "Pendolino"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "System"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "status"})(unscrambleDecodeSystemConfirmationStatus)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "APIIntegration"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "integration"})(unscrambleDecodeIntegrationId)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({reflectSymbol: () => "PosBistro"}))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "AutoCallCenter"
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({reflectSymbol: () => "Portal"}))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "Unknown"
    }))))))))))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericConfirmationSource.to($0(x));
  })()
};
const genericConfirmation = {to: x => x, from: x => x};
const showConfirmation = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["confirmedAt", DateUtils.formatISODateTime(v.confirmedAt)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "message",
            (() => {
              if (v.message.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.message._1) + ")"; }
              if (v.message.tag === "Nothing") { return "Nothing"; }
              $runtime.fail();
            })()
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["source", showConfirmationSource.show(v.source)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "status",
            showConfirmationStatus.show(v.status)
          ]))([]))));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "Confirmation"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeConfirmation = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "confirmedAt"})(Data$dUTCTime.unscrambleDecodeUTCTime)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "message"
    })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({reflectSymbol: () => "source"})(unscrambleDecodeConfirmationSource)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "status"
    })(unscrambleDecodeConfirmationStatus)(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodingOpts = /* #__PURE__ */ (() => (
  {
    sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: true,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
  }
))();
const encodeSystemConfirmationStatus = {
  encode: x => {
    const $0 = genericSystemConfirmationStatus.from(x);
    if ($0.tag === "Inl") { return "PaymentDeclined"; }
    if ($0.tag === "Inr") {
      if ($0._1.tag === "Inl") { return "PaymentTimeout"; }
      if ($0._1.tag === "Inr") {
        if ($0._1._1.tag === "Inl") { return "PaymentAfterRestaurantClosed"; }
        if ($0._1._1.tag === "Inr") {
          if ($0._1._1._1.tag === "Inl") { return "ConfirmationTimeout"; }
          if ($0._1._1._1.tag === "Inr") { return "Invalidated"; }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  }
};
const encodeShortOrderId = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ShortOrderId"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    }).encodeOpts(encodingOpts)
  }
))();
const encodeProductType = {
  encode: x => {
    const $0 = genericProductType.from(x);
    if ($0.tag === "Inl") { return "Promotion"; }
    if ($0.tag === "Inr") {
      if ($0._1.tag === "Inl") { return "External"; }
      if ($0._1.tag === "Inr") { return "Legacy"; }
      $runtime.fail();
    }
    $runtime.fail();
  }
};
const encodeParameterDescription = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ParameterDescription"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "parameter"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      }))({reflectSymbol: () => "choice"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const encodeOrderUUID = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "OrderUUID"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    }).encodeOpts(encodingOpts)
  }
))();
const encodeOrderDraft = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "OrderDraft"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    }).encodeOpts(encodingOpts)
  }
))();
const encodeModifierItemDescription = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ModifierItemDescription"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "value"
      })({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({reflectSymbol: () => "quantity"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({
        reflectSymbol: () => "modifierItem"
      })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const encodeModifierDescription = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ModifierDescription"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "vatRate"
      })({encodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dModifier.encodeModifierVatRate.encode}))({reflectSymbol: () => "value"})({
        encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode
      }))({reflectSymbol: () => "removedItems"})((() => {
        const $0 = Data$dFunctor.arrayMap(encodeModifierItemDescription.encode);
        return {encodeWithOptions: v => $0};
      })()))({reflectSymbol: () => "modifier"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "includedItems"})((() => {
        const $0 = Data$dFunctor.arrayMap(encodeModifierItemDescription.encode);
        return {encodeWithOptions: v => $0};
      })()))({reflectSymbol: () => "addedItems"})((() => {
        const $0 = Data$dFunctor.arrayMap(encodeModifierItemDescription.encode);
        return {encodeWithOptions: v => $0};
      })());
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const encodeProductPartDescription = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ProductPartDescription"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "vatRate"
      })({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dTaxes.encodeVatRate.encode(v2._1); }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "value"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({reflectSymbol: () => "product"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      }))({reflectSymbol: () => "parameters"})((() => {
        const $0 = Data$dFunctor.arrayMap(encodeParameterDescription.encode);
        return {encodeWithOptions: v => $0};
      })()))({reflectSymbol: () => "modifiers"})((() => {
        const $0 = Data$dFunctor.arrayMap(encodeModifierDescription.encode);
        return {encodeWithOptions: v => $0};
      })()))({reflectSymbol: () => "category"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const encodeItemRole = {
  encode: x => {
    const $0 = genericItemRole.from(x);
    if ($0.tag === "Inl") { return "Main"; }
    if ($0.tag === "Inr") {
      if ($0._1.tag === "Inl") { return "Side"; }
      if ($0._1.tag === "Inr") {
        if ($0._1._1.tag === "Inl") { return "Freebie"; }
        if ($0._1._1.tag === "Inr") { return "Info"; }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  }
};
const encodeItemDescription = {
  encode: /* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "FreebieDescription"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "vatRate"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dTaxes.encodeVatRate.encode(v2._1); }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "freebie"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "TextDescription"})((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "vatRate"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dTaxes.encodeVatRate.encode(v2._1); }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "description"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ProductDescription"})((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "vatRate"
      })({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dTaxes.encodeVatRate.encode(v2._1); }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "productParts"})((() => {
        const $2 = Data$dFunctor.arrayMap(encodeProductPartDescription.encode);
        return {encodeWithOptions: v => $2};
      })()))({reflectSymbol: () => "parameters"})((() => {
        const $2 = Data$dFunctor.arrayMap(encodeParameterDescription.encode);
        return {encodeWithOptions: v => $2};
      })()))({reflectSymbol: () => "modifiers"})((() => {
        const $2 = Data$dFunctor.arrayMap(encodeModifierDescription.encode);
        return {encodeWithOptions: v => $2};
      })());
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "NoDescription"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return x => {
      const $4 = genericItemDescription.from(x);
      if ($4.tag === "Inl") {
        return $0.encodeOpts({
          sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
          unwrapSingleConstructors: false,
          unwrapSingleArguments: true,
          unwrapSingleRecordArguments: true,
          fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
        })($4._1);
      }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") {
          return $1.encodeOpts({
            sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: true,
            unwrapSingleRecordArguments: true,
            fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
          })($4._1._1);
        }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") {
            return $2.encodeOpts({
              sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: true,
              unwrapSingleRecordArguments: true,
              fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
            })($4._1._1._1);
          }
          if ($4._1._1.tag === "Inr") {
            return $3.encodeOpts({
              sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: true,
              unwrapSingleRecordArguments: true,
              fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
            })($4._1._1._1);
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const encodeIntegrationId = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "IntegrationId"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    }).encodeOpts(encodingOpts)
  }
))();
const encodeCustomer = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Customer"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "phone"
      })({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "originalPhone"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "name"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "email"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const encodeCorrectedTotal = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "CorrectedTotal"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "total"})({
        encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode
      }))({reflectSymbol: () => "reason"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const encodeConfirmationStatus = {
  encode: /* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Accepted"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "deliveryTime"})({
        encodeWithOptions: v => Data$dUTCTime.encodeUTCTime.encode
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Rejected"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return x => {
      if (x.tag === "Accepted") {
        return $0.encodeOpts({
          sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
          unwrapSingleConstructors: false,
          unwrapSingleArguments: true,
          unwrapSingleRecordArguments: true,
          fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
        })(x._1);
      }
      if (x.tag === "Rejected") {
        return $1.encodeOpts({
          sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
          unwrapSingleConstructors: false,
          unwrapSingleArguments: true,
          unwrapSingleRecordArguments: true,
          fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
        })(Data$dGeneric$dRep.NoArguments);
      }
      $runtime.fail();
    };
  })()
};
const encodeConfirmationSource = {
  encode: /* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "AutoCancel"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "PR"})((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "staffName"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "staffId"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ROS"})((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "terminalId"
      })({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "staffName"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "staffId"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Email"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "CallCenter"})((() => {
      const $4 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "adminUserId"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $4.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $5 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Printer"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $6 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Pendolino"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $7 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "System"})((() => {
      const $7 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "status"})({
        encodeWithOptions: v => encodeSystemConfirmationStatus.encode
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $7.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $8 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "APIIntegration"})((() => {
      const $8 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "integration"})({
        encodeWithOptions: v => encodeIntegrationId.encode
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $8.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $9 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "PosBistro"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $10 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "AutoCallCenter"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $11 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Portal"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $12 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Unknown"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return x => {
      const $13 = genericConfirmationSource.from(x);
      if ($13.tag === "Inl") {
        return $0.encodeOpts({
          sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
          unwrapSingleConstructors: false,
          unwrapSingleArguments: true,
          unwrapSingleRecordArguments: true,
          fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
        })($13._1);
      }
      if ($13.tag === "Inr") {
        if ($13._1.tag === "Inl") {
          return $1.encodeOpts({
            sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: true,
            unwrapSingleRecordArguments: true,
            fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
          })($13._1._1);
        }
        if ($13._1.tag === "Inr") {
          if ($13._1._1.tag === "Inl") {
            return $2.encodeOpts({
              sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: true,
              unwrapSingleRecordArguments: true,
              fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
            })($13._1._1._1);
          }
          if ($13._1._1.tag === "Inr") {
            if ($13._1._1._1.tag === "Inl") {
              return $3.encodeOpts({
                sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: true,
                unwrapSingleRecordArguments: true,
                fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
              })($13._1._1._1._1);
            }
            if ($13._1._1._1.tag === "Inr") {
              if ($13._1._1._1._1.tag === "Inl") {
                return $4.encodeOpts({
                  sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                  unwrapSingleConstructors: false,
                  unwrapSingleArguments: true,
                  unwrapSingleRecordArguments: true,
                  fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
                })($13._1._1._1._1._1);
              }
              if ($13._1._1._1._1.tag === "Inr") {
                if ($13._1._1._1._1._1.tag === "Inl") {
                  return $5.encodeOpts({
                    sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                    unwrapSingleConstructors: false,
                    unwrapSingleArguments: true,
                    unwrapSingleRecordArguments: true,
                    fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
                  })($13._1._1._1._1._1._1);
                }
                if ($13._1._1._1._1._1.tag === "Inr") {
                  if ($13._1._1._1._1._1._1.tag === "Inl") {
                    return $6.encodeOpts({
                      sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                      unwrapSingleConstructors: false,
                      unwrapSingleArguments: true,
                      unwrapSingleRecordArguments: true,
                      fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
                    })($13._1._1._1._1._1._1._1);
                  }
                  if ($13._1._1._1._1._1._1.tag === "Inr") {
                    if ($13._1._1._1._1._1._1._1.tag === "Inl") {
                      return $7.encodeOpts({
                        sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                        unwrapSingleConstructors: false,
                        unwrapSingleArguments: true,
                        unwrapSingleRecordArguments: true,
                        fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
                      })($13._1._1._1._1._1._1._1._1);
                    }
                    if ($13._1._1._1._1._1._1._1.tag === "Inr") {
                      if ($13._1._1._1._1._1._1._1._1.tag === "Inl") {
                        return $8.encodeOpts({
                          sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                          unwrapSingleConstructors: false,
                          unwrapSingleArguments: true,
                          unwrapSingleRecordArguments: true,
                          fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
                        })($13._1._1._1._1._1._1._1._1._1);
                      }
                      if ($13._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if ($13._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                          return $9.encodeOpts({
                            sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                            unwrapSingleConstructors: false,
                            unwrapSingleArguments: true,
                            unwrapSingleRecordArguments: true,
                            fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
                          })($13._1._1._1._1._1._1._1._1._1._1);
                        }
                        if ($13._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if ($13._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                            return $10.encodeOpts({
                              sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                              unwrapSingleConstructors: false,
                              unwrapSingleArguments: true,
                              unwrapSingleRecordArguments: true,
                              fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
                            })($13._1._1._1._1._1._1._1._1._1._1._1);
                          }
                          if ($13._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if ($13._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                              return $11.encodeOpts({
                                sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                                unwrapSingleConstructors: false,
                                unwrapSingleArguments: true,
                                unwrapSingleRecordArguments: true,
                                fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
                              })($13._1._1._1._1._1._1._1._1._1._1._1._1);
                            }
                            if ($13._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              return $12.encodeOpts({
                                sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
                                unwrapSingleConstructors: false,
                                unwrapSingleArguments: true,
                                unwrapSingleRecordArguments: true,
                                fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
                              })($13._1._1._1._1._1._1._1._1._1._1._1._1);
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const encodeConfirmation = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Confirmation"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "status"
      })({encodeWithOptions: v => encodeConfirmationStatus.encode}))({reflectSymbol: () => "source"})({encodeWithOptions: v => encodeConfirmationSource.encode}))({
        reflectSymbol: () => "message"
      })({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "confirmedAt"})({encodeWithOptions: v => Data$dUTCTime.encodeUTCTime.encode});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const decodeSystemConfirmationStatus = {
  decode: /* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.genericDecodeEnum(genericSystemConfirmationStatus)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "PaymentDeclined"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "PaymentTimeout"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "PaymentAfterRestaurantClosed"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "ConfirmationTimeout"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "Invalidated"}))))))(Foreign$dGeneric$dEnumEncoding.defaultGenericEnumOptions)
};
const decodeShortOrderId = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericShortOrderId)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "ShortOrderId"})({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
const decodeProductType = {
  decode: /* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.genericDecodeEnum(genericProductType)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Promotion"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "External"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "Legacy"}))))(Foreign$dGeneric$dEnumEncoding.defaultGenericEnumOptions)
};
const decodeParameterDescription = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericParameterDescription)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ParameterDescription"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "parameter"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "choice"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
const decodeOrderUUID = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericOrderUUID)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "OrderUUID"})({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
const decodeOrderDraft = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericOrderDraft)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "OrderDraft"})({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign$dGeneric$dClass.foreignDecode.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
const decodeModifierItemDescription = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericModifierItemDescription)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ModifierItemDescription"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "value"
  })({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "quantity"})({
    decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "modifierItem"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
const decodeModifierDescription = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericModifierDescription)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ModifierDescription"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "vatRate"
  })({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dModifier.decodeModifierVatRate.decode})())({reflectSymbol: () => "value"})({
    decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode
  })())({reflectSymbol: () => "removedItems"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeModifierItemDescription);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "modifier"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "includedItems"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeModifierItemDescription);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "addedItems"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeModifierItemDescription);
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
const decodeProductPartDescription = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericProductPartDescription)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ProductPartDescription"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "vatRate"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dTaxes.decodeVatRate.decode)})())({reflectSymbol: () => "value"})({
    decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode
  })())({reflectSymbol: () => "product"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "parameters"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeParameterDescription);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "modifiers"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeModifierDescription);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "category"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
const decodeItemRole = {
  decode: /* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.genericDecodeEnum(genericItemRole)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Main"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "Side"}))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Freebie"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "Info"})))))(Foreign$dGeneric$dEnumEncoding.defaultGenericEnumOptions)
};
const decodeItemDescription = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericItemDescription)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "FreebieDescription"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "vatRate"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dTaxes.decodeVatRate.decode)})())({reflectSymbol: () => "freebie"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "TextDescription"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "vatRate"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dTaxes.decodeVatRate.decode)})())({reflectSymbol: () => "description"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ProductDescription"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "vatRate"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dTaxes.decodeVatRate.decode)})())({reflectSymbol: () => "productParts"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeProductPartDescription);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "parameters"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeParameterDescription);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "modifiers"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeModifierDescription);
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "NoDescription"})(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))))(encodingOpts)
};
const decodeIntegrationId = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericIntegrationId)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "IntegrationId"
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
const decodeCustomer = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericCustomer)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "Customer"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "phone"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "originalPhone"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))
  })())({reflectSymbol: () => "name"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({
    reflectSymbol: () => "email"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
const decodeCorrectedTotal = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericCorrectedTotal)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CorrectedTotal"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "total"
  })({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "reason"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
const decodeConfirmationStatus = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericConfirmationStatus)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Accepted"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "deliveryTime"
  })({decodeWithOptions: v => Data$dUTCTime.decodeUTCTime.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Rejected"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))(encodingOpts)
};
const decodeConfirmationSource = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericConfirmationSource)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "AutoCancel"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "PR"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "staffName"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "staffId"})({
    decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ROS"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "terminalId"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readInt(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "staffName"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))
  })())({reflectSymbol: () => "staffId"})({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Email"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CallCenter"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "adminUserId"
  })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Printer"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Pendolino"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "System"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "status"
  })({decodeWithOptions: v => decodeSystemConfirmationStatus.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "APIIntegration"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "integration"
  })({decodeWithOptions: v => decodeIntegrationId.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "PosBistro"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "AutoCallCenter"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Portal"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Unknown"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))))))))))))))(encodingOpts)
};
const decodeConfirmation = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericConfirmation)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "Confirmation"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "status"
  })({decodeWithOptions: v => decodeConfirmationStatus.decode})())({reflectSymbol: () => "source"})({decodeWithOptions: v => decodeConfirmationSource.decode})())({
    reflectSymbol: () => "message"
  })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "confirmedAt"})({
    decodeWithOptions: v => Data$dUTCTime.decodeUTCTime.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
export {
  $ConfirmationSource,
  $ConfirmationStatus,
  $ItemDescription,
  $ItemRole,
  $ProductType,
  $SystemConfirmationStatus,
  APIIntegration,
  Accepted,
  AutoCallCenter,
  AutoCancel,
  CallCenter,
  Confirmation,
  ConfirmationTimeout,
  CorrectedTotal,
  Customer,
  Email,
  External,
  Freebie,
  FreebieDescription,
  Info,
  IntegrationId,
  Invalidated,
  Legacy,
  Main,
  ModifierDescription,
  ModifierItemDescription,
  NoDescription,
  OrderDraft,
  OrderUUID,
  PR,
  ParameterDescription,
  PaymentAfterRestaurantClosed,
  PaymentDeclined,
  PaymentTimeout,
  Pendolino,
  Portal,
  PosBistro,
  Printer,
  ProductDescription,
  ProductPartDescription,
  Promotion,
  ROS,
  Rejected,
  ShortOrderId,
  Side,
  System,
  TextDescription,
  Unknown,
  decodeConfirmation,
  decodeConfirmationSource,
  decodeConfirmationStatus,
  decodeCorrectedTotal,
  decodeCustomer,
  decodeIntegrationId,
  decodeItemDescription,
  decodeItemRole,
  decodeModifierDescription,
  decodeModifierItemDescription,
  decodeOrderDraft,
  decodeOrderUUID,
  decodeParameterDescription,
  decodeProductPartDescription,
  decodeProductType,
  decodeShortOrderId,
  decodeSystemConfirmationStatus,
  encodeConfirmation,
  encodeConfirmationSource,
  encodeConfirmationStatus,
  encodeCorrectedTotal,
  encodeCustomer,
  encodeIntegrationId,
  encodeItemDescription,
  encodeItemRole,
  encodeModifierDescription,
  encodeModifierItemDescription,
  encodeOrderDraft,
  encodeOrderUUID,
  encodeParameterDescription,
  encodeProductPartDescription,
  encodeProductType,
  encodeShortOrderId,
  encodeSystemConfirmationStatus,
  encodingOpts,
  eqConfirmation,
  eqConfirmationSource,
  eqConfirmationStatus,
  eqCorrectedTotal,
  eqCustomer,
  eqIntegrationId,
  eqItemDescription,
  eqItemRole,
  eqModifierDescription,
  eqModifierItemDescription,
  eqOrderDraft,
  eqOrderUUID,
  eqParameterDescription,
  eqProductPartDescription,
  eqProductType,
  eqShortOrderId,
  eqSystemConfirmationStatu,
  genericConfirmation,
  genericConfirmationSource,
  genericConfirmationStatus,
  genericCorrectedTotal,
  genericCustomer,
  genericIntegrationId,
  genericItemDescription,
  genericItemRole,
  genericModifierDescription,
  genericModifierItemDescription,
  genericOrderDraft,
  genericOrderUUID,
  genericParameterDescription,
  genericProductPartDescription,
  genericProductType,
  genericShortOrderId,
  genericSystemConfirmationStatus,
  hasFieldConfirmation,
  hasFieldCorrectedTotal,
  hasFieldCustomer,
  hasFieldModifierDescription,
  hasFieldModifierItemDescription,
  hasFieldParameterDescription,
  hasFieldProductPartDescription,
  newtypeConfirmation,
  newtypeCorrectedTotal,
  newtypeCustomer,
  newtypeIntegrationId,
  newtypeModifierDescription,
  newtypeModifierItemDescription,
  newtypeOrderDraft,
  newtypeOrderUUID,
  newtypeParameterDescription,
  newtypeProductPartDescription,
  newtypeShortOrderId,
  showConfirmation,
  showConfirmationSource,
  showConfirmationStatus,
  showCorrectedTotal,
  showCustomer,
  showIntegrationId,
  showItemDescription,
  showItemRole,
  showModifierDescription,
  showModifierItemDescription,
  showOrderDraft,
  showOrderUUID,
  showParameterDescription,
  showProductPartDescription,
  showProductType,
  showShortOrderId,
  showSystemConfirmationStatus,
  unscrambleDecodeConfirmation,
  unscrambleDecodeConfirmationSource,
  unscrambleDecodeConfirmationStatus,
  unscrambleDecodeCorrectedTotal,
  unscrambleDecodeCustomer,
  unscrambleDecodeIntegrationId,
  unscrambleDecodeItemDescription,
  unscrambleDecodeItemRole,
  unscrambleDecodeModifierDescription,
  unscrambleDecodeModifierItemDescription,
  unscrambleDecodeOrderDraft,
  unscrambleDecodeOrderUUID,
  unscrambleDecodeParameterDescription,
  unscrambleDecodeProductPartDescription,
  unscrambleDecodeProductType,
  unscrambleDecodeShortOrderId,
  unscrambleDecodeSystemConfirmationStatus
};
